import styled from '@emotion/styled'
import { Box } from '@mui/material'

import { CTAButton } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { transientOptions } from '@f-fertighaus/applications/Next/utils/transientOptions'

export const HouseDescriptionTextContainer = styled(Box, transientOptions)<{
  $expanded?: boolean
}>`
  overflow: hidden;
  transition: max-height 0.5s ease-out;
`

export const ExposeDownloadButton = styled(CTAButton)`
  .MuiButton-startIcon {
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`
